import axios from "@/util/axios";
import _ from "lodash";

export default {
  state: {},
  mutations: {
    DICT_SET_NAME(state, obj) {
      state[obj.key] = obj.value;
    },
  },
  actions: {
    async getDictData(context, params = {}) {
      const [err, res] = await axios.post("/data_dict/list", {
        type: [
          "review_subject",
          "review_core_issues",
          "review_risk_level",
          "review_is_violation",
          "review_is_ack",
          "order_callback_type",
          "collect_type",
          "callback_cate"
        ],
        currentPage: 1,
        pageSize: 2000,
      });
      if (err) return;

      let newGroup = _.groupBy(res.list, "type");
      // 把每一个字典存起来
      for (const key in newGroup) {
        context.commit("DICT_SET_NAME", {
          key,
          value: newGroup[key],
        });
      }
    },
  },
};
